<div class="rss-feed-container">
  <h2 class="h4 widget-header" i18n="rss feed header@@rss-feed-header">RSS-feed</h2>
  <h3 class="text-muted h6" i18n="rss feed sub header@@rss-feed-sub-header">Read the latest post about us in media.</h3>

  <div *ngIf="subscribedToRssFeature">
    <div *ngIf="isFeedUrlConfigured; else noFeeds">
      <div *ngIf="feeds$ | async as feeds; else loading" class="feed-wrapper">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3 mt-4 pl-3 pr-3" *ngFor="let feedItem of feeds">
            <div class="feed-content p-3">
              <div class="pb-1"><span class="text-muted small metadata-text">{{feedItem.TagName}}</span></div>
              <div class="text-muted pb-1 pt-2"><span class="">{{feedItem.PublishedDate| date}}</span></div>
              <div class="feed-title">
                <h4 class="h6">
                  <a href="{{feedItem.Url}}" class="feed-clickable-link"><span class="extra-bold">{{feedItem.Title}}</span></a>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfFeeds > amountCurrentlyShowing && amountCurrentlyShowing < amountToFetch && !feedLoading else showLess">
          <div class="col-auto">
            <button mat-flat-button color="accent" class="feed-show-more-btn" (click)="showMoreFeeds()"><span i18n="feeds show more@@feeds-show-more">Show more posts</span><i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i></button>
          </div>
        </div>
        <ng-template #showLess>
          <div class="row justify-content-center mt-4" *ngIf="amountCurrentlyShowing > amountToShowPerLoad && !feedLoading">
            <div class="col-auto">
              <button mat-flat-button color="accent" class="feed-show-more-btn" (click)="showLessFeeds()"><span i18n="feeds show less@@feeds-show-less">Show less posts</span><i class="ml-2 ms-Icon ms-Icon--ChevronUp" aria-hidden="true"></i></button>
            </div>
          </div>
        </ng-template>

        <div *ngIf="feeds.length === 0">
          <app-text-placeholder>
            <p i18n="no post@@no-posts">No posts to show.</p>
          </app-text-placeholder>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loading>
  <div>
    <app-widget-placeholder></app-widget-placeholder>
  </div>
</ng-template>

<ng-template #noFeeds>
  <div>
    <app-text-placeholder>
      <p i18n="no feeds@@no-feeds">Please configure the feed source URI.</p>
    </app-text-placeholder>
  </div>
</ng-template>
